import React from 'react';
import { Checkbox, message, Popconfirm } from 'antd';
import processError from '../../../utils/processError';

interface WebActiveViewActiveProps {
  itemName: string;
  setLoading: (loading: boolean) => void;
  reloadPageData: () => Promise<void>;
  toggleWebviewActive: () => Promise<void>;
  currentActiveValue: boolean;
}

function WebViewActiveCheckbox({
  itemName,
  setLoading,
  reloadPageData,
  toggleWebviewActive,
  currentActiveValue,
}: WebActiveViewActiveProps) {
  async function handleToggleWebviewActive() {
    try {
      setLoading(true);
      await toggleWebviewActive();
      await reloadPageData();
      message.success(currentActiveValue ? `Ẩn ${itemName} thành công` : `Hiện ${itemName} thành công`);
    } catch (err) {
      processError(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Popconfirm
      title={currentActiveValue ? `Ẩn ${itemName}` : `Hiện ${itemName}`}
      description={currentActiveValue ? `Xác nhận ẩn ${itemName} trên web?` : `Xác nhận hiện ${itemName} trên web?`}
      onConfirm={handleToggleWebviewActive}
      okText="Đồng ý"
      cancelText="Hủy"
    >
      <Checkbox checked={currentActiveValue} />
    </Popconfirm>
  );
}

export default WebViewActiveCheckbox;
